import React from 'react'
import StyledAdminWrapper from './StyledAdminWrapper'


const Music = React.lazy(() => import(/* webpackChunkName: 'admin-music' */ 'components_v2/Admin/Music'))

const StyledMusic = ({ ...rest }) => {
  return (
    <StyledAdminWrapper>
      <Music {...rest} />
    </StyledAdminWrapper>
  )
}

export default StyledMusic
